// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1F9yP7SO3glUDxZhduzb-6","itemInfo":"_1lIZ0ZMI0wCd3dGhQb8UB-","labelSmall":"_3c8ijVyXYaqGKYXd8EyPW1 _2O2hTwnmOrrmrKGIZ0TBbb _1gAPANzKL6QTHxsrUemGt9","formItem":"_144gxoxinI3a4T1GHVzBgg","input":"_31eArm2cA0os6n-TKLDzhQ"};


//////////////////
// WEBPACK FOOTER
// ./src/AddPractice/Associations/custom-mention-values.css
// module id = 818
// module chunks = 0